import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Image360Viewer from "./Image360Viewer";

function TabData() {
  const location = useLocation();
  const slug = location.pathname.split("/")[2];
  const [post, setPost] = useState([]);
  const ImageURL = "https://www.indianarmour.com/indianarmourcms/";

  useEffect(() => {
    const API = `https://www.indianarmour.com/indianarmourcms/APIs/Product/producttab.php?page=${slug}`;
    fetch(API)
      .then((res) => res.json())
      .then((res) => setPost(res))
      .catch((err) => console.error("Error fetching data:", err));
  }, [slug]);

  return (
    <>
      <section className="armed-vehicle right-black-bg">
        <div className="container">
          <div className="armed-tab">
            {/* Tabs */}
            <ul className="nav nav2 nav-pills mb-3" id="pills-tab" role="tablist">
              {post.map((item, i) => (
                <li className="nav-item" role="presentation" key={item?.tab_name || i}>
                  <button
                    className={`nav-link ${i === 0 ? "active" : ""}`}
                    id={`vest${i}`}
                    data-bs-toggle="pill"
                    data-bs-target={`#Vest-detail${i}`}
                    type="button"
                    role="tab"
                    aria-selected={i === 0}
                  >
                    {item?.tab_name}
                  </button>
                </li>
              ))}
            </ul>

            {/* Tab Content */}
            <div className="tab-content tab-content2" id="pills-tabContent">
              {post.map((item, i) => (
                <div
                  className={`tab-pane fade show ${i === 0 ? "active" : ""}`}
                  id={`Vest-detail${i}`}
                  role="tabpanel"
                  key={`tab-content-${i}`}
                >
                  {slug === "tactical-vest" && i === 0 ? (
                    <div className="row align-items-center">
                      <div className="col-lg-6">
                        <div className="Vest-description-p">
                          <div dangerouslySetInnerHTML={{ __html: item?.content }} />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <Image360Viewer
                          path="/images/products/"
                          filePrefix="military-vest"
                          fileExt=".png"
                          frameCount={36}
                          padLength={3}
                          width={600}
                          height={500}
                          autoplay={false}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="Vest-description-p">
                      <div dangerouslySetInnerHTML={{ __html: item?.content }} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
{/* Extra Section */}
{/* <section className="tab-descripton pb-5">
  <div className="container">
    <div className="row">
      <div className="col-lg-12">
        {post.length > 0 && (
          <div className="vest-description">
            {[1, 2, 3, 4].map((num) => {
              const imgData = post[0]?.tabimage?.[num]; // use only first item
              return (
                <div className="ballistic-vesta-box m-0" key={`img-${num}`}>
                  {imgData && (
                    <Link
                      to={
                        num === 1
                          ? "/bespoke-solutions"
                          : num === 2
                          ? "/ballistic-products-customization-bulk-ordering"
                          : num === 3
                          ? "/vertical-integration"
                          : "#"
                      }
                    >
                      <ul>
                        <li className="vesta-box">
                          <img src={ImageURL + imgData?.image} alt="" />
                        </li>
                        <li
                          dangerouslySetInnerHTML={{
                            __html: imgData?.heading,
                          }}
                        />
                      </ul>
                    </Link>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  </div>
</section> */}

<section className="tab-descripton pb-5">
  <div className="container">
    <div className="row">
      <div className="col-lg-12">
        <div className="vest-description">
          <div className="ballistic-vesta-box m-0">
            <a href="/bespoke-solutions">
              <ul>
                <li className="vesta-box">
                  <img
                    src="https://www.indianarmour.com/indianarmourcms/media/product_tab/203/203_tabimage_file0.svg"
                    alt=""
                  />
                </li>
                <li>
                  Bespoke
                  <br />
                  Solutions
                </li>
              </ul>
            </a>
          </div>
          <div className="ballistic-vesta-box m-0">
            <a href="/ballistic-products-customization-bulk-ordering">
              <ul>
                <li className="vesta-box">
                  <img
                    src="https://www.indianarmour.com/indianarmourcms/media/product_tab/203/203_tabimage_file1.svg"
                    alt=""
                  />
                </li>
                <li>
                  Bulk <br />
                  Ordering
                </li>
              </ul>
            </a>
          </div>
          <div className="ballistic-vesta-box m-0">
            <a href="/vertical-integration">
              <ul>
                <li className="vesta-box">
                  <img
                    src="https://www.indianarmour.com/indianarmourcms/media/product_tab/203/203_tabimage_file2.svg"
                    alt=""
                  />
                </li>
                <li>
                  5 Year
                  <br /> Warranty
                </li>
              </ul>
            </a>
          </div>
          <div className="ballistic-vesta-box m-0">
            <a href="/product/tactical-vest">
              <ul>
                <li className="vesta-box">
                  <img
                    src="https://www.indianarmour.com/indianarmourcms/media/product_tab/203/203_tabimage_file3.svg"
                    alt=""
                  />
                </li>
                <li>
                  NIJ
                  <br /> Standards
                </li>
              </ul>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </>
  );
}

export default TabData;
